<template>
  <el-collapse v-model="activeNames">
    <el-collapse-item :title="video_table.typeName" :name="video_table.typeCode" style="text-align: left; ">
      <table id="test" class="am-table am-table-hover" :class="{ 'b3': videos_is_live, 'b1': !videos_is_live}">
        <!-- 直播内容格式 -->
        <!--        <tbody v-if="videos_is_live">-->
        <!--        <tr v-for="video in video_table.videos" @click="gotoVideo(video)"-->
        <!--            :class="{cur: current_id===video.videoId}" :id="video.videoId">-->
        <!--          <td>-->
        <!--            <div style="display:flex;flex-direction: row;align-items: center">-->
        <!--              <a v-if="video.isLive === 1">{{ video.videoName }}</a>-->
        <!--              <a v-if="video.isLive === 0" style="margin-right: 10px"> {{ video.v_index + video.videoName }}</a>-->
        <!--              <a v-if="video.isLive === 0" style="margin-left: auto;margin-right: 10px;color: #999999;font-size: 12px">{{-->
        <!--                  video.duration | durationTimeFormat-->
        <!--                }}</a>-->
        <!--            </div>-->
        <!--          </td>-->
        <!--        </tr>-->
        <!--        </tbody>-->
        <tbody>
        <tr v-for="video in video_table.videos" @click="gotoVideo(video)"
            :class="{cur: current_id===video.videoId && video.module_type === 1}" :id="video.videoId">
          <td>
            <div v-if="video.module_type === 1">
              <div style="display:flex;flex-direction: row;align-items: center;">
                <a v-if="video.isLive === 1">{{ video.videoName }}</a>
                <a v-if="video.isLive === 0" style="margin-right: 10px"> {{ video.v_index + video.videoName }}</a>
                <a v-if="video.isLive === 0"
                   style="margin-left: auto;margin-right: 10px;color: #999999;font-size: 12px">{{
                    video.duration | durationTimeFormat
                  }}</a>
                <img v-if="video.isLive === 0 && video.show_light === 1"
                     style="height: 15px; width: 15px;margin-right: 10px" src="../../common/images/video_com.png">
              </div>
              <el-progress v-if="video.isLive === 0 && !isNaN((video.beyondTime / video.duration) * 100)"
                           :percentage="(video.beyondTime / video.duration) * 100" :show-text="false"
                           style="margin-top: 10px;margin-right: 10px"/>
            </div>
            <div
              v-if="video.module_type !== 1"
              style="display:flex;flex-direction: row;align-items: center;">
              <a>{{ video.title }}</a>
              <a style="margin-left: auto;margin-right: 10px;color: #999999;font-size: 12px">{{
                  video.desc
                }}</a>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </el-collapse-item>
  </el-collapse>
</template>
<script>
export default {
  name: 'video_table_panel',
  data() {
    return {
      activeNames: ['00', '01', '02', '03', '04', '05', '06', '07', '08']
    };
  },
  props: ['video_table', 'current_id', 'has_buy'],
  computed: {
    // 直播判断
    videos_is_live: function () {
      return false
    }
  },
  methods: {
    // 选择视频：
    gotoVideo: function (video) {
      if(!this.has_buy && video.videoTypeId !== '201703131201518576196927'){
        this.$message.error("您还未购买该课程");
        return false;
      }
      if (video.module_type === 1) {
        if (video.videoId) {
          this.$emit('childmethods', video.videoId, video.videoTypeId);
        }
      } else if(video.module_type === 5) {
        window.location.href = video.h5_url;
      } else {
        this.$message.error("请在小程序或APP上打开");
      }
    },
    showPDF: function (pdf_url) {
      if (!this.has_buy) {
        this.$message.error("您还未购买该课程");
        return false;
      } else {
        window.open(pdf_url);
      }
    },
    scrollToChild: function (video_id) {
      document.getElementById(video_id).scrollIntoView({block: 'nearest'});
    },
  },
  filters: {
    getDateFromTimestr(value) {
      var temparr = value.split("T")[0].split("-")
      return temparr[1] + '月' + temparr[2] + '日'
    },
    getTimeFromTimestr(value) {
      return value.split("T")[1]
    },
    durationTimeFormat(value) {
      var temp = [];
      temp = value >= 3600 ? [Math.floor(value / 3600), Math.floor(value % 3600 / 60), value % 60] : [Math.floor(value / 60), value % 60]
      for (var i in temp) {
        temp[i] = temp[i] < 10 ? '0' + temp[i] : temp[i];
      }
      return temp.join(":");
    },
  }
}

</script>
<style>
.el-collapse {
  border-top: 0 #f2f2f2 solid !important;
  background: #ffffff !important;
}

.el-collapse,
.el-collapse-item__header,
.el-collapse-item__wrap {
  border-bottom: 1px solid #f2f2f2 !important;
}

.el-collapse-item__header {
  font-size: 14px !important;
  color: #333333 !important;
  background: #ffffff !important;
  padding-left: 20px;
}

.el-collapse-item__content {
  padding-bottom: 0 !important;
}

.el-collapse-item__header {
  height: 50px !important;
}

.el-progress-bar__outer {
  height: 2px !important;
}

.el-progress-bar__inner {
  border-radius: 1px;
}
</style>

<style scoped>
.am-tabs-bd .am-tab-panel * {
  -webkit-user-drag: none;
}

.am-table {
  width: 100%;
  border-spacing: 0;
  border-collapse: separate;
}

.am-table tr {
  background: #f9f9f9;
}

table {
  max-width: 100%;
  background-color: transparent;
  empty-cells: show;
  cursor: pointer;
}

#vdtable table thead {
  background: #f2f2f2;
  border: none;
  color: #666;
}

#vdtable .am-tabs-bd .b1 tbody td:first-child, #bsk-class-tabs .am-tabs-bd .b3 tbody td {
  color: #e37d28;
  font-size: 14px;
}

#vdtable .am-table-hover > tbody > tr.cur td {
  background-color: #f9f9f9;
}

#vdtable .am-tabs-bd table td {
  border-top: none;
  border-bottom: 1px solid #f2f2f2;
}

.am-tabs-bd .am-tab-panel * {
  -webkit-user-drag: none;
}

.am-table > tbody > tr > td > span {
  color: #9b9b9b;
  font-size: 14px;
}

.am-table > thead > tr > td, .am-table > thead > tr > th {
  padding: .7rem;
  line-height: 1.6;
  vertical-align: top;
  border-top: 1px solid #ddd;
  color: #666;
  font-size: 14px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

.am-table > tbody > tr > td {
  padding-left: 30px;
  padding-top: 10px;
  padding-bottom: 10px;
  color: #666666;
  cursor: pointer;
  font-size: 13px !important;
  border-bottom: 1px #f2f2f2 solid;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

.am-table > thead > tr > td.wide,
.am-table > tbody > tr > td.wide {
  text-align: center;
  font-size: 14px;
  color: #666;
}

.am-table-hover > tbody > tr:hover {
  /*color: #fff;*/
  /*background-color: #e37d28;*/
  /*background-color: #f5f7fa;*/
}

.am-table-hover > tbody > tr.cur span {
  color: #e37d28;
}

.am-table-hover > tbody > tr.cur i {
  display: inline-block;
}

.am-table-hover > tbody > tr.cur td {
  background-color: #FFF9ED;
  color: #ffbc42 !important;
}

.am-table-hover > tbody > tr i {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Video/VideoTable.vue